import React from 'react'
import { useNavigate } from 'react-router-dom';

import classes from './../Onboarding.module.scss';
import UpperDiv from './UpperDiv';
import LowerDiv from './LowerDiv';
import no_site_loc_1 from './../../../assets/onboarding/no_site_loc_1.svg'
import no_site_loc_2 from './../../../assets/onboarding/no_site_loc_2.svg'
import no_site_loc_3 from './../../../assets/onboarding/no_site_loc_3.svg'
import no_site_loc_4 from './../../../assets/onboarding/no_site_loc_4.svg'
import Pagination from './Pagination';

const upperDivStyle = {
  display: "flex",
  alignItems: 'flex-end',
  justifyContent: 'center',
  flexDirection: 'column'
}

const lowerDivStyle = {
  display: "flex",
  flexDirection: 'column',
  gap: '0'
}

const no_site_loc_1_style = {
  position: "absolute",
  maxWidth: '90%',
  top: 20,
  left: 10
}

const no_site_loc_2_style = {
  position: "absolute",
  maxWidth: '90%',
  right: 10,
  marginTop: 100,
  zIndex: 99
}

const no_site_loc_3_style = {
  position: "absolute",
  left: 10,
  bottom: 50,
  maxWidth: '90%',
  zIndex: 99
}


const no_site_loc_4_style = {
  marginLeft: "-20px",
  maxWidth: '35%',
}

const Page5 = () => {
  const navigate = useNavigate();

  return (
    <>
      <UpperDiv style={upperDivStyle}>
        <img src={no_site_loc_1} alt="" style={no_site_loc_1_style} />
        <img src={no_site_loc_2} alt="" style={no_site_loc_2_style} />
        <img src={no_site_loc_3} alt="" style={no_site_loc_3_style} />
      </UpperDiv>
      <LowerDiv style={lowerDivStyle}>
        <div className={classes.Page2Div}>
          <img src={no_site_loc_4} alt="" style={no_site_loc_4_style} />
          <h3 className={classes.Page2H3}>
            In Case No Site location
          </h3>
          <p className={classes.NameH3} >
            In case your mobile is not able to fetch location enter your
            location site in the input and mark your attendance.
          </p>
        </div>
        <div className={classes.Page2Pagination}>
          <div style={{ display: 'flex', width: "100%" }}>
            <button onClick={() => { navigate('/onboarding/4') }}>
              PREV
            </button>
            <button onClick={() => { navigate('/onboarding/6') }}>
              NEXT
            </button>
          </div>
          <Pagination numberOfDots={7} activePage={5} />
        </div>
      </LowerDiv>
    </>
  )
}

export default Page5